<template>
  <vs-popup title='Add New Broker Promo Code' :active.sync="showDialog">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input label="Name *" class="w-full" v-model="addForm.form.name"/>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/2 w-full">
        <vs-select label="Broker *" v-model="addForm.form.brokerId" autocomplete>
          <vs-select-item :key="index" :value="broker.id" :text="broker.name" v-for="broker,index in this.brokers" />
        </vs-select>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input type="number" label="Percentage Discount for Guest (%) *" class="w-full" v-model="addForm.form.percentage"/>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input type="number" label="Commission on base (%) *" class="w-full" v-model="addForm.form.commissionOnBooking"/>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input type="number" label="Number of usage *" class="w-full" v-model="addForm.form.numberOfUsage"/>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input type="date" label="Start Date *" class="w-full" v-model="addForm.form.startDate"/>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input type="date" label="End Date *" class="w-full" v-model="addForm.form.endDate"/>
      </div>
    </div>

    <div class="mt-5">
      <vs-button color="primary" type="filled" @click="addPromo">ADD</vs-button>
      <vs-button color="dark" type="flat" style="float: right" @click="hide">Cancel</vs-button>
    </div>

  </vs-popup>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "AddFeatureComponent",
    data() {
      return {
        showDialog: false,
        imageUrl: null,
        addForm: {
          form: {
            name: null,
            percentage: null,
            numberOfUsage: 1,
            startDate: null,
            endDate: null,
            commissionOnBooking: null,
            brokerId : null
          },
          url: 'admin/brokers-promos',
          commitUrl: 'promos/SET_PROMO',
          storeName: 'promos',
          needLoading: true,
        },
      }
    },
    computed: {
      ...mapGetters({
        brokers: 'brokers/brokersList'
      })
    },
    async created(){
      if(!this.brokers){
        await this.loadAllBrokers({  
          storeName: 'brokers',
          url: `admin/brokers`,
          commitUrl: 'brokers/SET_BROKERS',
          needLoading: true
        })
      }
    },
    watch: {
      error(newValue) {
        if (newValue != null) {
          this.errorNotify()
        }
      }
    },
    methods: {
      ...mapActions({
        add: 'add',
        loadAllBrokers: 'get',
      }),
      errorNotify(msg){
        this.$vs.notify({color:'danger',title:'Error',text:msg})
      },
      async addPromo() {
        if(!this.addForm.form.name){
          this.errorNotify("You haven't written the promocode name!")
          return;
        }
        if(!this.addForm.form.brokerId){
          this.errorNotify("You haven't chosen a Broker!")
          return;
        }
        if(!this.addForm.form.percentage){
          this.errorNotify("You haven't entered the promocode percentage discount!")
          return;
        }
        if(!this.addForm.form.commissionOnBooking){
          this.errorNotify("You haven't entered the broker's commission percentage!")
          return;
        }
        if(!this.addForm.form.startDate){
          this.errorNotify("Please choose the promocode's start date!")
          return;
        }
        if(!this.addForm.form.endDate){
          this.errorNotify("Please choose the promocode's end date!")
          return;
        }
        await this.add(this.addForm)
        this.hide()
      },
      show() {
        this.showDialog = true
      },
      hide(){
        this.showDialog = false
      },
      clearForm(){
        this.addForm = {
          form: {
            name: null,
            percentage: null,
            numberOfUsage: 1,
            startDate: null,
            endDate: null,
            commissionOnBooking: null,
          },
          url: 'admin/brokers-promos',
          commitUrl: 'promos/SET_PROMO',
          storeName: 'promos',
          needLoading: true,
        }
      }
    }
  }
</script>

<style scoped>

</style>
